// extracted by mini-css-extract-plugin
export default {"label":"ConsultParticipantsModal__label--pYO3s","modalMainProvider":"ConsultParticipantsModal__modalMainProvider--AOW2F"};